/* Copyright (c) 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SubmitHandler } from "react-hook-form";
import { Resource } from "~/generated/graphql";
import { Item } from "~/types";
import { FormData } from "./formConfig";

export const enum ResourceMode {
  MANUAL,
  DYNAMIC,
}

export enum ResourceGroupField {
  DETAILS = "details",
  EXPRESSION = "expression",
  MANUAL_SELECTED_RESOURCES = "manual_selected_resources",
  DYNAMIC_RESOURCES = "dynamic_resources",
  RESOURCE_SELECTION_METHOD = "resource_selection_method",
  ALL_RESOURCES = "all_resources",
}

export type Props = {
  onSubmit: SubmitHandler<ResourceGroupData>;
  onDynamicSubmit: SubmitHandler<{ expression: string }>;
  setResourceGroupData: React.Dispatch<React.SetStateAction<ResourceGroupData>>;
  resourceGroupData: ResourceGroupData;
};

export type ResourceGroupData = {
  [ResourceGroupField.DETAILS]: FormData | undefined;
  [ResourceGroupField.EXPRESSION]?: string | undefined;
  [ResourceGroupField.RESOURCE_SELECTION_METHOD]?: ResourceMode | undefined;
  [ResourceGroupField.MANUAL_SELECTED_RESOURCES]: string[];
  [ResourceGroupField.DYNAMIC_RESOURCES]?: Item[] | undefined;
  [ResourceGroupField.ALL_RESOURCES]?: Resource[];
};

export const defaultValues: ResourceGroupData = {
  [ResourceGroupField.DETAILS]: undefined,
  [ResourceGroupField.EXPRESSION]: "",
  [ResourceGroupField.RESOURCE_SELECTION_METHOD]: undefined,
  [ResourceGroupField.MANUAL_SELECTED_RESOURCES]: [],
  [ResourceGroupField.DYNAMIC_RESOURCES]: undefined,
  [ResourceGroupField.ALL_RESOURCES]: [],
};
